document.addEventListener('change', function (e) {
  const input = e.target;
  if (!input.matches('input.productOption[type="radio"]')) return;

  // only for the Color option area
  const colorBlock = input.closest('.product-option-selector.select-color');
  if (!colorBlock) return;

  const label = colorBlock.querySelector('.selected-color-name');
  if (!label) return;

  label.textContent = input.value; // updates to what you clicked
});
